import { render, staticRenderFns } from "./TintometricoEmbalagem.vue?vue&type=template&id=73b2d108&scoped=true"
import script from "./TintometricoEmbalagem.vue?vue&type=script&lang=js"
export * from "./TintometricoEmbalagem.vue?vue&type=script&lang=js"
import style0 from "./TintometricoEmbalagem.vue?vue&type=style&index=0&id=73b2d108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b2d108",
  null
  
)

export default component.exports